import classNames from 'clsx';
import PropTypes from 'prop-types';
import { isXSmall } from '../../../utils/breakpoints';
import isDesktop from '../../../utils/desktop/isDesktop';
import ScrollReset from '../../shared/ScrollReset';
import { CarouselItems } from './CarouselItems';
import css from './gallery.module.scss';

export default function Carousel({
  showButtons,
  isLeftButtonDisabled,
  isRightButtonDisabled,
  handlePageLeft,
  handlePageRight,
  itemsMatrix,
  numRows,
  page,
  breakpoint,
  isExtendedInfoEnabled,
}) {
  const firstGuideItem = itemsMatrix[0][0];
  const isOnDesktop = isDesktop();

  return (
    <div className={css.relative} data-testid="containerGuideItemsContainer">
      {showButtons && (
        <div
          data-testid="containerLoadMoreLeftLink"
          onClick={handlePageLeft}
          onKeyDown={(event) => {
            // Trigger handlePageLeft only for 'Enter' or 'Space' key
            if (event.key === 'Enter' || event.key === ' ') {
              handlePageLeft();
            }
          }}
          /* biome-ignore lint/a11y/useSemanticElements: TODO: explore changing div to button */
          role="button" // A11y
          tabIndex={0} // A11y
          className={classNames(css.pager, css.left, {
            [css.desktopPager]: isOnDesktop,
            [css.hide]: isLeftButtonDisabled,
            [css.noBottomTile]: !firstGuideItem.title,
          })}
        >
          <i className={classNames(css.chevronLeft, css.chevron)} disabled={isLeftButtonDisabled} />
        </div>
      )}
      <ScrollReset
        scrollHash={isXSmall(breakpoint)}
        className={classNames(css.container, {
          [css.enableHorizontalScroll]: !showButtons,
        })}
      >
        <CarouselItems
          itemsMatrix={itemsMatrix}
          numRows={numRows}
          className={css.pad}
          page={page}
          breakpoint={breakpoint}
          isExtendedInfoEnabled={isExtendedInfoEnabled}
        />
      </ScrollReset>
      {showButtons && (
        <div
          data-testid="containerLoadMoreRightLink"
          onClick={handlePageRight}
          onKeyDown={(event) => {
            // Trigger handlePageRight only for 'Enter' or 'Space' key
            if (event.key === 'Enter' || event.key === ' ') {
              handlePageRight();
            }
          }}
          /* biome-ignore lint/a11y/useSemanticElements: TODO: explore changing div to button */
          role="button" // A11y
          tabIndex={0} // A11y
          className={classNames(css.pager, css.right, {
            [css.desktopPager]: isOnDesktop,
            [css.hide]: isRightButtonDisabled,
            [css.noBottomTile]: !firstGuideItem.title,
          })}
        >
          <i
            className={classNames(css.chevronRight, css.chevron)}
            disabled={isRightButtonDisabled}
          />
        </div>
      )}
    </div>
  );
}

Carousel.propTypes = {
  numRows: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  itemsMatrix: PropTypes.array.isRequired,
  breakpoint: PropTypes.number.isRequired,
  showButtons: PropTypes.bool.isRequired,
  isLeftButtonDisabled: PropTypes.bool.isRequired,
  isRightButtonDisabled: PropTypes.bool.isRequired,
  isExtendedInfoEnabled: PropTypes.bool,
  handlePageLeft: PropTypes.func.isRequired,
  handlePageRight: PropTypes.func.isRequired,
};
